<script setup lang="ts"></script>

<template>
  <v-row justify="space-around">
    <v-date-picker />
  </v-row>
</template>
